<template lang="pug">
  .form-wrapper(
    ref="formWrapper"
  )
    slot
</template>

<script>
  import FormValidation from 'scripts/helpers/formValidation.js';

  export default {
    name: "ContactForm",
    props: {
      webhookId: String,
      keyword: String,
    },
    data() {
      return {
        phoneSentToServer: false,
        form: false,
      };
    },
    mounted() {
      this.form = this.$refs.formWrapper.querySelector('form');
      this.form.addEventListener('submit', this.sendTextAlert);
      this.validateForm();
    },
    methods: {
      validateForm () {
        const requiredFields = this.$refs.formWrapper.querySelectorAll('input[required], textarea[required]');
        FormValidation.addFormValidation([...requiredFields]);
      },
      getAllInputValues () {
        const inputElements = [...this.$refs.formWrapper.querySelectorAll('.input input, .input select, .input textarea')];
        return inputElements.reduce((payload, inputEl) => {
          if (inputEl.hasAttribute('name')) {
            const name = inputEl.getAttribute('name')
                                .replace('contact[', '')
                                .replace(']', '');
            payload[name] = (inputEl.type === 'checkbox') ? inputEl.checked : inputEl.value;
          }
          return payload;
        }, {});
      },
      sendTextAlert(event) {
        if (!this.phoneSentToServer) {
          event.preventDefault();
          this.phoneSentToServer = true;

          const shouldSendEl = this.$refs.formWrapper.querySelector('[data-send-to-psio]');
          const phoneEl      = this.form.querySelector('input[name="contact[phone]"');
          const phoneNumber  = phoneEl.value;
          const webhook = `https://hook.integromat.com/${this.webhookId}`;
          const payload = JSON.stringify({
            keyword: this.keyword,
            ...this.getAllInputValues(),
          });

          fetch(webhook, {
            method: "POST",
            body: payload,
            headers: {
              "Content-Type": "application/json"
            }
          })
            .then((response) => this.form.submit())
            .catch((err) => this.form.submit());
        }
      },
    },
  };
</script>
